import { defineMigrations } from "@supersig/store";
/** @public */ export const navigationNodeProps = {};
/** @internal */ export const navigationNodeMigrations = defineMigrations({});
export const NavigationNodeInfo = {
    migrations: navigationNodeMigrations,
    props: navigationNodeProps,
    meta: {}
};
